import { useAbility } from '@casl/vue'
import { type AppAbility } from '@/services/ability'

export const useAppAbility = () => useAbility<AppAbility>()
